import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { filter, Observable } from 'rxjs';
import { ConfigurationService } from '../../services/configuration.service';
import { InviteUserRequest, WorkspaceUser, ChangeRoleRequest } from '../models/users';
import { DriftConfiguration } from 'src/app/models/configuration.interface';

@Injectable()
export class WorkspaceUserService {
  private readonly workspaceUrl = '/workspace';
  private config!: DriftConfiguration;
  constructor(
    private readonly httpClient: HttpClient,
    private readonly configurationService: ConfigurationService
  ) {
    //No unsub required
    this.configurationService
      .configurationLoaded()
      .pipe(filter(loaded => loaded === true))
      .subscribe(() => {
        this.config = this.configurationService.getConfiguration();
      });
  }

  private get apiUrl() {
    return `${this.config.driftApi}${this.workspaceUrl}`;
  }

  public inviteUser(workspaceId: string, data: InviteUserRequest): Observable<void> {
    const path = `${this.apiUrl}/${workspaceId}/user/invite`;
    return this.httpClient.post<void>(path, data);
  }

  public getUsers(workspaceId: string): Observable<WorkspaceUser[]> {
    const path = `${this.apiUrl}/${workspaceId}/user`;
    return this.httpClient.get<WorkspaceUser[]>(path);
  }

  public revokeAccess(workspaceId: string, userId: string): Observable<void> {
    const path = `${this.apiUrl}/${workspaceId}/user/${userId}/revoke`;
    return this.httpClient.post<void>(path, {});
  }

  public changeRole(workspaceId: string, userId: string, data: ChangeRoleRequest): Observable<void> {
    const path = `${this.apiUrl}/${workspaceId}/user/${userId}`;
    return this.httpClient.put<void>(path, data);
  }
}
